// extracted by css-extract-rspack-plugin
export default {"levelsGroup":"Smx52","calendarHeader":"BACEN","calendarHeaderControlIcon":"jXr5F"};